
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      imgArray: '',
      defaultImageUrl:
        'https://static.vecteezy.com/system/resources/previews/004/141/669/original/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg',
      page: 1,
      overlayNews: false,
    }
  },
  computed: {
    ...mapGetters('noticias', [
      'allNewsWP',
      'mediaSelectedWP',
      'newSelected',
      'WPSelected',
    ]),
  },
  watch: {
    page(page) {
      this.loadNews(page, 8)
    },
  },
  mounted() {
    this.loadNews()
  },
  methods: {
    ...mapActions('noticias', [
      'fetchNewsWP',
      'fetchNewsWPMediaSelected',
      'fetchNewsWPSelected',
    ]),
    redirectToNewsItem(item) {
      this.$router.push(`/blog/${item.slug}`)
    },

    async loadNews(page = 1, perPage = 8) {
      this.overlayNews = true
      try {
        await this.fetchNewsWP({ page, perPage })
      } catch (error) {
        console.error(error)
      }
      this.overlayNews = false
    },

    getNewsImage(newsItem) {
      if (
        newsItem.better_featured_image &&
        newsItem.better_featured_image.source_url
      ) {
        return newsItem.better_featured_image.source_url
      } else {
        return this.defaultImageUrl
      }
    },

    handleImageError(event) {
      event.target.src = this.defaultImageUrl
    },
  },
}
